export default __webpack_public_path__ + "static/media/one.5b79fcaf.svg";